/* eslint-disable @typescript-eslint/no-explicit-any */
import { convertToDecimals } from '@pharmaplan/common';

export const handlerForZeroes = {
  get(obj: any, prop: string) {
    if (!obj[prop] || obj[prop] === 0) {
      return '';
    }
    return Reflect.get(obj, prop);
  },
};

export const decimalConverterProxy = {
  get(obj: any, prop: string) {
    if (obj[prop]) {
      return convertToDecimals(Reflect.get(obj, prop));
    }
    return Reflect.get(obj, prop);
  },
};

export const parseFloatProxy = {
  get(obj: any, prop: string) {
    if (obj[prop]) {
      return parseFloat(Reflect.get(obj, prop));
    }
    return Reflect.get(obj, prop);
  },
};

export const parseEmptyStringProxy = {
  get(obj: any, prop: string) {
    if (!obj[prop]) {
      return 0;
    }
    return Reflect.get(obj, prop);
  },
};

export const convertToNullProxy = {
  get(obj: any, prop: string) {
    if (obj[prop] === '') {
      return null;
    }
    return Reflect.get(obj, prop);
  },
};
